<template>
  <div>
    <transition name="fade">
      <p v-show="!isLittleScroll" class="mb-1 label-12 all-ease-in-out" :class="{'transition-margin-top': isLittleScroll}">Nama Outlet</p>
    </transition>
    <b-dropdown
      ref="dropdownStores"
      aria-role="menu"
      expanded
      append-to-body
      :close-on-click="false"
      @active-change="handleClickDropdown"
    >
      <template #trigger>
        <div
          class="input-search-2 flex-center adjust-input-clients border-radius-5"
          :class="[classInput]"
        >
          <div class="vendor-filter-icon">
            <VendorFilter />
          </div>
          <b-input
            ref="inputStoresReadonly"
            :value="selectedOutlets"
            placeholder="Semua Outlet"
            class="input-none c-w-100 pr-4"
            readonly
          >
          </b-input>
          <div
            v-if="selectedOutlets !== 'Semua Outlet'"
            class="close-wrapper"
            @click="handleClearSearch"
          >
            <XMarkIcon size="10" color="#000" />
          </div>
        </div>
      </template>

      <div class="item-dropdown-client-wrapper">
        <ItemListDropdown
          :datas="stores"
          title="Pilih Outlet"
          idItem="store_id"
          nameItem="store_name"
          :showSearch="true"
          :keywordProps="keywordStore"
          @handleSelectData="handleSelectData"
        />
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DropdownClients',
  props: {
    isLittleScroll: {
      type: Boolean,
      default: false
    },
    classInput: {
      type: String,
      default: ''
    }
  },
  components: {
    XMarkIcon: () => import('@/components/icons/XMarkIcon'),
    VendorFilter: () => import('@/components/icons/VendorFilter.vue'),
    ItemListDropdown: () => import('./ItemListDropdown.vue')
  },
  data () {
    return {
      keywordStore: '',
      stores: []
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      getListStores: 'report/getListStores'
    }),
    selectedOutlets () {
      if (this.stores.filter((item) => item.selected).length < 1) {
        return 'Semua Outlet'
      }
      return this.stores
        .filter((item) => item && item.selected)
        .map((item) => item && item.store_name)
        .join(', ')
    }
  },
  methods: {
    handleClearSearch () {
      this.keywordStore = ''
      this.stores = this.stores.map(item => ({ ...item, selected: false }))

      let reset = false
      const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
      if (isFiltered) {
        reset = true
      }
      this.$emit('selected', { data: '', type: 'stores', reset })
      if (this.$refs.dropdownStores.isActive) {
        this.$refs.dropdownStores.toggle()
      }
    },
    handleSelectData (props) {
      this.stores = this.stores.map((item) =>
        item.store_id === props.store_id
          ? { ...item, selected: props.selected }
          : item
      )

      const result = props.datas
        .filter((item) => item.selected)
        .map((item) => item.store_id)
        .join(',')
      this.$emit('selected', { data: result, type: 'stores' })

      this.$nextTick(() => {
        const inputEl = this.$refs.inputStoresReadonly.$el.querySelector('input')
        inputEl.scrollLeft = inputEl.scrollWidth
      })
      localStorage.setItem('report_selected_stores', JSON.stringify({ result }))
    },
    handlePageRefresh () {
      const temp = {
        stores: this.stores,
        keywordStore: this.keywordStore
      }
      localStorage.setItem('report_dropdown_stores', JSON.stringify(temp))
    },
    handleClickDropdown (value) {
      this.$emit('clickedDropdown', value)
    }
  },
  mounted () {
    this.stores = this.getListStores

    const temp = localStorage.getItem('report_dropdown_stores')
    if (temp) {
      this.stores = JSON.parse(temp).stores
      this.keywordStore = JSON.parse(temp).keywordStore

      const selected = localStorage.getItem('report_selected_stores')
      const result = selected && JSON.parse(selected).result
      this.$emit('selected', { data: result, type: 'stores' })
    }
  },
  watch: {
    getListStores: {
      handler (val) {
        this.stores = val
      },
      deep: true
    }
  },
  created () {
    window.addEventListener('beforeunload', this.handlePageRefresh)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handlePageRefresh)
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.adjust-input-clients {
  padding: 2.4px;
  padding-left: 20px;
  position: relative;
  width: 230px;
}

.vendor-filter-icon {
  position: absolute;
  left: 5px;
  top: 9.5px;
  z-index: 2;
}

.item-dropdown-client-wrapper {
  overflow: auto;
  max-height: 280px;
}

.close-wrapper {
  position: absolute;
  right: -1px;
  top: 3px;
  padding: 5px 10px;
  cursor: pointer;
}
</style>
